module.exports = __webpack_public_path__ + "static/media/bg2.6f8d19aa.png";